module.exports = __webpack_public_path__ + "static/service1-e2dd086dae61d64b985d5dfd2f64c58a.png";